import type { WebsiteDiscoveryJob } from '@shared/api-client';
import { LoaderCircle } from 'lucide-react';

const stages = {
  queued: 'Starting your setup…',
  reading: 'Reading your website…',
  reviewing: 'Preparing your tracking setup…',
  analyzing: 'Choosing your goals…',
  complete: 'Setup prepared',
};

export const DiscoveryProgress = ({ job }: { job?: WebsiteDiscoveryJob }) => {
  const sources = job?.result?.websiteResearch?.sources ?? [];
  return (
    <div className="space-y-2 py-2">
      <p
        className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm"
        role="status"
      >
        <span className="flex items-center gap-2 font-medium text-ink">
          <LoaderCircle
            aria-hidden
            className="size-4 shrink-0 animate-spin motion-reduce:animate-none"
          />
          {stages[job?.stage ?? 'queued']}
        </span>
        {sources.length > 0 && (
          <span className="text-ink-muted">
            {sources.length} {sources.length === 1 ? 'page' : 'pages'} reviewed
          </span>
        )}
      </p>
      <details className="ml-6 text-sm text-ink-muted">
        <summary className="w-fit cursor-pointer py-1 hover:text-ink">
          Details
        </summary>
        <div className="mt-2 space-y-3">
          {sources.length > 0 && (
            <ul className="space-y-1">
              {sources.map((source) => (
                <li key={source.url} className="break-words">
                  {source.title || new URL(source.url).hostname}
                </li>
              ))}
            </ul>
          )}
          <p>
            Analysis can take up to two minutes. You can refresh or return to
            this tab.
          </p>
        </div>
      </details>
    </div>
  );
};
